var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _rect, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataSciencePreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 259,
    viewBox: "0 0 212 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.454 127.607C12.454 124.916 10.7489 124.837 10.7489 124.837C10.7489 124.837 9.82325 124.837 8.32519 124.215C6.84541 123.6 4.75665 123.838 5.92587 125.988C5.93805 126.012 5.95022 126.042 5.9624 126.067C6.03548 126.182 6.15727 126.292 6.33996 126.402L10.0668 128.588C10.6393 128.911 12.4418 128.162 12.454 127.607Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4478 127.364C12.4174 127.918 10.6331 128.655 10.0729 128.332L6.346 126.146C6.22421 126.073 6.01104 125.933 5.82227 125.762C5.8588 125.835 5.88928 125.908 5.93191 125.988C5.94409 126.012 5.95627 126.042 5.96845 126.067C6.04152 126.182 6.16331 126.292 6.346 126.402L10.0729 128.588C10.6027 128.892 12.2225 128.253 12.4357 127.717C12.4478 127.674 12.4539 127.638 12.4539 127.607C12.4539 127.522 12.4478 127.443 12.4478 127.364Z",
    fill: "#1E1C6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7658 124.483C11.3273 124.483 9.78056 124.879 9.78056 124.879C9.78056 124.879 9.76839 125.092 9.64051 125.281C9.62224 125.299 9.61006 125.318 9.59788 125.336C9.29339 125.549 8.98282 125.884 9.70749 126.341C10.2982 126.712 10.7854 126.475 11.0107 126.249C11.102 126.079 11.2421 125.884 11.4309 125.774C11.6257 125.659 11.7476 125.61 11.8328 125.604C11.8328 125.592 11.8389 125.567 11.8389 125.567C11.8389 125.567 11.9485 124.483 11.7658 124.483Z",
    fill: "#FFD3AB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3019 120.519C25.6076 118.016 24.7977 115.964 24.1218 113.029C22.5019 112.706 8.20951 108.315 8.13035 111.33C8.04509 114.423 9.71974 125.038 9.71974 125.038C9.75019 125.159 9.84764 125.275 10.006 125.366C10.414 125.598 11.0716 125.598 11.4736 125.366C11.6563 125.263 11.8085 125.123 11.8268 124.983H11.8329C11.8329 124.983 11.7476 117.432 11.4736 114.198C15.9129 117.645 23.6224 121.408 26.3019 120.519Z",
    fill: "#292929"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16212 131.225C7.16212 128.533 5.45702 128.454 5.45702 128.454C5.45702 128.454 4.5314 128.454 3.03335 127.833C1.55356 127.218 -0.535197 127.455 0.627928 129.605C0.640107 129.629 0.652291 129.66 0.67056 129.684C0.743636 129.8 0.865426 129.909 1.04812 130.019L4.77498 132.205C5.34132 132.528 7.14994 131.779 7.16212 131.225Z",
    fill: "#C0162E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14996 130.981C7.11951 131.535 5.33523 132.272 4.77498 131.949L1.04812 129.763C0.926322 129.69 0.713193 129.55 0.524414 129.38C0.560952 129.453 0.591396 129.526 0.634023 129.605C0.646203 129.629 0.658386 129.66 0.676655 129.684C0.749731 129.8 0.871522 129.909 1.05421 130.019L4.78108 132.205C5.31088 132.51 6.93073 131.87 7.14387 131.334C7.14996 131.292 7.16212 131.255 7.16212 131.225C7.16212 131.139 7.15605 131.066 7.14996 130.981Z",
    fill: "#292929"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46796 128.101C6.0295 128.101 4.48272 128.496 4.48272 128.496C4.48272 128.496 4.47052 128.71 4.34264 128.898C4.32437 128.917 4.31218 128.935 4.3 128.953C3.99552 129.166 3.68498 129.501 4.40965 129.958C5.00035 130.329 5.48749 130.092 5.71281 129.867C5.80415 129.696 5.94422 129.501 6.133 129.392C6.32787 129.276 6.44968 129.227 6.53494 129.221C6.53494 129.209 6.54103 129.185 6.54103 129.185C6.54103 129.185 6.48623 128.515 6.46796 128.101Z",
    fill: "#FFD3AB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9393 116.743C17.3195 116.421 4.3302 110.343 3.05747 112.828C2.99657 112.944 2.9722 113.078 2.9722 113.224C2.35106 116.366 4.42154 128.655 4.42154 128.655C4.45199 128.777 4.54944 128.892 4.70778 128.984C5.11578 129.221 5.77345 129.215 6.17537 128.984C6.35806 128.88 6.51031 128.74 6.52858 128.6C6.52858 128.6 7.21063 120.665 6.99749 117.821C11.5221 121.731 18.3182 124.039 20.8393 123.978C25.6014 123.856 27.8667 121.366 28.8959 118.595C29.2673 117.59 29.444 114.91 29.444 113.753C24.6575 111.378 20.5165 114.216 18.9393 116.743Z",
    fill: "#292929"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7311 116.628C59.2409 112.304 49.4304 110.142 39.6139 110.142C36.2281 110.142 32.8483 110.404 29.5599 110.916C29.5355 111.835 29.499 112.779 29.4564 113.753C29.4564 114.916 29.2798 117.59 28.9083 118.595C27.873 121.365 25.6077 123.856 20.8517 123.978C18.629 124.033 13.0995 122.248 8.72716 119.155C8.38613 119.423 8.06339 119.691 7.74673 119.965V119.959C5.8224 121.615 4.32434 123.393 3.25256 125.232C3.23429 125.263 3.2282 125.293 3.20993 125.318C1.91892 127.571 1.26123 129.921 1.26123 132.278C1.26123 137.941 5.00638 143.611 12.4967 147.935C19.9869 152.258 29.7974 154.42 39.6139 154.42V132.278L66.7311 116.628Z",
    fill: "#CACACB"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3707 116.037C46.2393 113.918 29.4623 113.528 29.4623 113.528C29.4562 113.607 29.4562 113.68 29.4502 113.76C29.4502 114.923 29.2735 117.596 28.9021 118.601C28.5489 119.545 28.3114 119.886 28.147 120.178C27.9764 120.47 27.8608 120.629 27.7694 120.738C26.4601 122.541 24.3227 123.893 20.8455 123.978C18.6227 124.033 13.0933 122.249 8.72094 119.155C8.37992 119.423 8.05718 119.691 7.74052 119.965V119.959C7.60045 120.081 7.46649 120.202 7.33252 120.324C12.1982 123.509 16.7045 124.684 21.2047 124.684C25.705 124.684 45.9714 124.593 48.3646 122.2C50.764 119.807 50.5021 118.156 48.3707 116.037Z",
    fill: "url(#paint1_linear)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55089 112.858C2.39995 110.021 1.3099 107.305 0.274654 104.716C0.207668 104.552 0.299023 104.345 0.475623 104.241C4.71402 101.793 6.83321 100.569 11.0777 98.1213C11.1386 98.0848 11.1995 98.0726 11.2604 98.0726L11.2665 98.0665H11.0107V98.0726C10.9498 98.0726 10.8828 98.0787 10.8219 98.1213C6.58354 100.569 4.46436 101.793 0.219868 104.241C0.0493577 104.339 -0.0419975 104.552 0.018899 104.716C1.04805 107.305 2.14419 110.021 3.29514 112.858C3.34385 112.98 3.45348 113.041 3.56918 113.041V113.047H3.84318L3.83103 113.041C3.71533 113.041 3.6057 112.98 3.55089 112.858Z",
    fill: "#313131"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7983 106.397C14.8592 106.562 14.7678 106.775 14.5973 106.878C10.3589 109.326 8.23972 110.55 4.00132 112.998C3.83081 113.096 3.62986 113.041 3.55679 112.858C2.40584 110.021 1.31579 107.305 0.280547 104.716C0.213561 104.552 0.304916 104.345 0.481516 104.241C4.71992 101.793 6.8391 100.569 11.0836 98.1213C11.2541 98.0239 11.4551 98.0665 11.5221 98.231C12.6304 100.868 13.7874 103.742 14.7983 106.397Z",
    fill: "#292929"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0.597412 104.534C0.80446 105.051 3.59352 111.994 3.82492 112.56C4.40344 112.225 13.8668 106.799 14.4453 106.47C14.2382 105.934 11.4248 98.9434 11.2056 98.4197C10.621 98.7546 1.17593 104.199 0.597412 104.534Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80132 106.275C7.41767 105.319 7.80744 104.156 8.66608 103.669C9.52472 103.182 10.5417 103.559 10.9193 104.515C11.3029 105.472 10.8949 106.61 10.0362 107.098C9.17761 107.585 8.17888 107.231 7.80132 106.275Z",
    fill: "#59595B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51763 108.206C5.13398 107.256 5.52374 106.086 6.38239 105.599C7.24103 105.112 8.25801 105.496 8.63557 106.446C9.01312 107.396 8.6051 108.516 7.74646 109.003C6.88782 109.491 5.90128 109.15 5.51763 108.206Z",
    fill: "#292929"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M5.35975 105.301C4.9822 104.369 5.39627 103.267 6.24882 102.774C7.10746 102.281 8.094 102.591 8.47156 103.529C8.85521 104.467 8.47157 105.648 7.60684 106.135C6.7482 106.622 5.73731 106.233 5.35975 105.301Z",
    fill: "#C0162E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8863 105.35C12.4722 105.581 12.2651 105.703 11.8571 105.934C11.6318 105.855 11.5161 105.813 11.2908 105.733C11.3334 105.612 11.3578 105.551 11.4004 105.423C11.5831 105.49 11.6744 105.52 11.8571 105.587C12.2286 105.38 12.4113 105.277 12.7766 105.064C12.8193 105.179 12.8436 105.234 12.8863 105.35Z",
    fill: "#C0162E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7142 103.992C4.53151 103.937 4.44623 103.906 4.26354 103.852C3.89816 104.065 3.70941 104.168 3.34403 104.381C3.3014 104.278 3.28311 104.223 3.24048 104.12C3.65458 103.882 3.85554 103.766 4.26963 103.529C4.48886 103.596 4.60458 103.626 4.82381 103.699C4.78118 103.815 4.76292 103.876 4.7142 103.992Z",
    fill: "#C0162E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5.37159 108.656C4.90877 108.918 4.67738 109.052 4.20848 109.314C4.15976 109.198 4.1354 109.138 4.09277 109.022C4.55559 108.76 4.78698 108.626 5.25588 108.364C5.29851 108.486 5.32287 108.541 5.37159 108.656Z",
    fill: "#C0162E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1329 117.474C11.3034 117.572 11.5896 117.572 11.7662 117.474L22.3562 111.36C22.5267 111.263 22.5267 111.098 22.3562 110.995L15.1399 106.829C14.9694 106.732 14.6832 106.732 14.5066 106.829L3.9167 112.944C3.74619 113.041 3.74619 113.205 3.9167 113.309L11.1329 117.474Z",
    fill: "#F7F7FC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4877 107.7L15.0053 107.396L14.7495 107.25L14.2319 107.548L14.4877 107.7Z",
    fill: "#EAEEF9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6171 108.2L14.1347 107.901L13.879 107.755L13.3613 108.054L13.6171 108.2Z",
    fill: "#EAEEF9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.746 108.705L13.2636 108.407L13.0018 108.255L12.4841 108.553L12.746 108.705Z",
    fill: "#EAEEF9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8754 109.211L12.393 108.912L12.1312 108.76L11.6135 109.058L11.8754 109.211Z",
    fill: "#EAEEF9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9984 109.71L11.5222 109.412L11.2603 109.265L10.7427 109.564L10.9984 109.71Z",
    fill: "#EAEEF9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1278 110.215L10.6455 109.917L10.3897 109.765L9.87207 110.063L10.1278 110.215Z",
    fill: "#EAEEF9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25672 110.721L9.77437 110.422L9.51252 110.27L8.99487 110.569L9.25672 110.721Z",
    fill: "#EAEEF9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38612 111.22L8.90376 110.922L8.64187 110.776L8.12427 111.074L8.38612 111.22Z",
    fill: "#EAEEF9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50893 111.726L8.03263 111.427L7.77078 111.275L7.25317 111.579L7.50893 111.726Z",
    fill: "#EAEEF9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63832 112.231L7.15593 111.933L6.90017 111.78L6.38257 112.079L6.63832 112.231Z",
    fill: "#EAEEF9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76722 112.737L6.28483 112.432L6.02907 112.286L5.50537 112.584L5.76722 112.737Z",
    fill: "#EAEEF9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89662 113.236L5.41422 112.937L5.15237 112.791L4.63477 113.09L4.89662 113.236Z",
    fill: "#EAEEF9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9507 108.437L15.8824 107.901L15.3648 107.603L14.4331 108.139L14.9507 108.437Z",
    fill: "#EAEEF9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4317 109.125L16.7166 108.382L16.199 108.084L14.9141 108.827L15.4317 109.125Z",
    fill: "#EAEEF9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9492 109.838L17.5874 108.888L17.0698 108.589L15.4316 109.533L15.9492 109.838Z",
    fill: "#EAEEF9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7155 110.033L18.6472 109.497L17.9408 109.095L17.0151 109.631L17.7155 110.033Z",
    fill: "#EAEEF9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4303 110.776L17.362 110.24L16.6556 109.838L15.7239 110.374L16.4303 110.776Z",
    fill: "#EAEEF9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1456 111.519L16.0712 110.983L15.3709 110.575L14.4392 111.117L15.1456 111.519Z",
    fill: "#EAEEF9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7122 114.076L11.644 113.54L10.9376 113.138L10.0059 113.674L10.7122 114.076Z",
    fill: "#EAEEF9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53232 115.337L10.3592 114.283L9.65893 113.875L7.83203 114.935L8.53232 115.337Z",
    fill: "#EAEEF9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9908 113.339L14.786 111.726L14.0857 111.318L11.2905 112.931L11.9908 113.339Z",
    fill: "#EAEEF9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8362 109.083L14.5974 108.644L14.0798 108.346L13.3125 108.784L13.8362 109.083Z",
    fill: "#EAEEF9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3172 109.771L15.0784 109.332L14.5608 109.034L13.7996 109.472L14.3172 109.771Z",
    fill: "#EAEEF9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8106 110.465L15.5718 110.027L15.0542 109.728L14.293 110.167L14.8106 110.465Z",
    fill: "#EAEEF9"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6903 111.111L14.4576 110.672L13.9338 110.374L13.1726 110.812L13.6903 111.111Z",
    fill: "#EAEEF9"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5757 111.756L13.3369 111.318L12.8193 111.019L12.0581 111.458L12.5757 111.756Z",
    fill: "#EAEEF9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4612 112.402L12.2224 111.957L11.7048 111.659L10.9436 112.103L11.4612 112.402Z",
    fill: "#EAEEF9"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3409 113.047L11.1082 112.603L10.5844 112.304L9.82324 112.743L10.3409 113.047Z",
    fill: "#EAEEF9"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22635 113.687L9.98755 113.248L9.46995 112.95L8.70874 113.388L9.22635 113.687Z",
    fill: "#EAEEF9"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M7.45441 114.716L8.87327 113.893L8.35567 113.595L6.93677 114.417L7.45441 114.716Z",
    fill: "#EAEEF9"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1968 110.416L13.958 109.978L13.4404 109.679L12.6792 110.118L13.1968 110.416Z",
    fill: "#EAEEF9"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0823 111.062L12.8435 110.623L12.3259 110.319L11.5647 110.763L12.0823 111.062Z",
    fill: "#EAEEF9"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M10.968 111.707L11.7293 111.263L11.2116 110.964L10.4504 111.409L10.968 111.707Z",
    fill: "#EAEEF9"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84772 112.353L10.6089 111.908L10.0913 111.61L9.33008 112.048L9.84772 112.353Z",
    fill: "#EAEEF9"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73318 112.992L9.49439 112.554L8.97678 112.255L8.21558 112.694L8.73318 112.992Z",
    fill: "#EAEEF9"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60183 114.222L8.38 113.199L7.8624 112.901L6.08423 113.924L6.60183 114.222Z",
    fill: "#EAEEF9"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7158 109.728L13.4771 109.29L12.9594 108.991L12.1982 109.43L12.7158 109.728Z",
    fill: "#EAEEF9"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6014 110.374L12.3626 109.935L11.8449 109.637L11.0837 110.075L11.6014 110.374Z",
    fill: "#EAEEF9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4871 111.019L11.2483 110.581L10.7307 110.276L9.96338 110.721L10.4871 111.019Z",
    fill: "#EAEEF9"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36648 111.665L10.1277 111.22L9.61008 110.922L8.84888 111.366L9.36648 111.665Z",
    fill: "#EAEEF9"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25202 112.304L9.01323 111.866L8.49558 111.567L7.73438 112.006L8.25202 112.304Z",
    fill: "#EAEEF9"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13772 112.95L7.89892 112.511L7.38132 112.213L6.61401 112.651L7.13772 112.95Z",
    fill: "#EAEEF9"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76736 113.741L6.77823 113.157L6.26062 112.858L5.24976 113.443L5.76736 113.741Z",
    fill: "#EAEEF9"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27435 112.45L13.6415 107.615L13.3919 107.469L5.02466 112.304L5.27435 112.45Z",
    fill: "#292929"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M11.991 113.961L16.2659 111.494L18.9149 113.029L14.6461 115.495L11.991 113.961Z",
    fill: "#EAEEF9"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91012 113.309L11.1264 117.474C11.2664 117.553 11.4735 117.572 11.6379 117.523C11.6379 117.523 11.7414 117.48 11.7597 117.474L22.3496 111.36C22.3618 111.354 22.3739 111.348 22.38 111.336L22.3861 111.33C22.3922 111.324 22.3983 111.318 22.4044 111.318L22.4105 111.312C22.4166 111.305 22.4227 111.299 22.4288 111.293C22.4348 111.287 22.4409 111.275 22.447 111.269C22.4592 111.245 22.4714 111.22 22.4714 111.196V111.348C22.4714 111.415 22.4287 111.482 22.3435 111.531L11.7536 117.645C11.5039 117.773 11.1386 117.748 11.035 117.724C10.9254 117.7 10.8341 117.675 10.7184 117.651L3.91012 113.717C3.82487 113.668 3.78223 113.601 3.78223 113.534V113.138C3.78223 113.193 3.82487 113.26 3.91012 113.309Z",
    fill: "url(#paint2_linear)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5341 109.052L14.9143 109.99L19.8226 112.822V112.986L21.4424 112.048V111.884L16.5341 109.052Z",
    fill: "url(#paint3_linear)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8613 98.103C22.7029 99.327 22.9222 100.849 20.9613 104.436C20.3402 105.569 18.0139 108.705 17.1857 109.241C16.936 108.839 15.8947 108.431 15.7059 108.328C15.5172 108.224 14.8777 108.151 14.5123 108.376C14.4271 108.425 14.1531 108.583 13.946 108.754C13.5989 109.028 13.9338 109.308 14.3236 109.265C14.7133 109.223 14.8107 109.332 15.1944 109.649C15.2614 109.704 15.3223 109.771 15.3771 109.838C15.1518 109.746 14.7986 109.497 14.5428 109.789C14.7559 109.929 15.4867 110.313 16.0774 110.392C16.2418 110.422 16.9178 110.398 17.1979 110.349C18.4402 110.148 21.2232 108.382 23.0988 105.843C26.3324 101.458 26.6247 99.6315 26.6308 98.5354C26.6551 95.6001 23.0683 96.0873 22.8613 98.103Z",
    fill: "url(#paint4_linear)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4613 119.368C21.4726 121.603 16.3878 120.69 18.2634 116.171C19.2804 114.003 19.6883 110.215 19.6092 107.95C19.2377 107.103 18.0502 106.836 17.4839 104.601C17.356 102.871 17.3316 102.195 17.6605 98.7972C19.0976 97.0982 19.7675 96.3187 21.3752 95.6854C22.3434 95.3017 23.604 94.8145 24.5296 95.3809C28.5427 97.8533 29.8215 105.337 29.4501 113.753C29.036 116.506 27.4283 118.266 25.4613 119.368Z",
    fill: "#292929"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6528 95.7401C22.9951 95.0764 22.7698 93.5966 22.6967 92.4213C22.7881 91.7758 22.7759 91.0876 22.6237 90.3812C22.0756 87.8479 20.0295 86.1428 18.0442 86.5691C16.0651 86.9954 14.8959 89.3947 15.444 91.928C15.9494 94.2725 17.8859 95.6244 19.7067 95.8802C19.8955 96.2456 19.4205 96.8484 19.1586 97.1347C20.6445 97.5853 22.1365 96.7145 22.8916 96.3369C23.2813 96.142 23.5615 95.9533 23.6528 95.7401Z",
    fill: "#FFD3AB"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6441 113.54L11.3456 113.595C11.096 113.595 10.8463 113.735 9.7806 113.358C9.48221 113.248 9.06813 112.858 8.7332 112.852C8.36782 112.852 8.08769 112.828 7.89282 112.791C8.0816 112.858 8.36173 112.919 8.7332 112.974C9.06204 113.023 9.42135 113.473 9.70147 113.619C9.87198 113.711 10.012 113.772 10.1399 113.833L14.1104 116.122V116.281L15.986 115.197V115.038L12.6915 113.138C12.2774 113.358 11.9181 113.498 11.6441 113.54Z",
    fill: "url(#paint5_linear)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5815 99.2601C17.4232 100.484 17.3684 103.791 15.4075 107.372C14.7864 108.504 12.7768 111.981 11.7354 112.304C11.5832 112.274 11.4005 112.237 11.1447 111.939C10.7855 111.506 10.3957 111.22 10.1521 111.038C9.90246 111.208 10.28 111.671 10.4992 111.86C10.4992 111.86 10.0669 111.72 9.65887 111.561C9.44573 111.482 8.46529 111.397 8.31914 111.403C7.43005 111.452 7.25953 111.671 7.81978 111.762C6.87589 111.738 7.19256 112.048 7.48486 112.109C7.16211 112.243 7.21083 112.456 7.72236 112.481C7.30827 112.67 7.67363 112.846 8.72714 112.852C9.06207 112.852 9.47618 113.248 9.77458 113.358C10.8403 113.741 11.0899 113.595 11.3396 113.595L11.638 113.54C12.8803 113.339 15.6633 111.318 17.5389 108.778C20.7725 104.394 21.3388 100.789 21.351 99.6864C21.3693 96.7573 17.7886 97.2445 17.5815 99.2601Z",
    fill: "url(#paint6_linear)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6247 97.4392C26.7465 96.1117 25.7234 95.6245 24.6151 94.6258C22.8674 93.0486 24.0244 93.3043 23.2023 90.3509C22.3802 87.3974 19.9565 85.2416 16.8386 86.3073C15.2614 86.8493 14.3236 89.4191 15.9434 91.3495C18.2758 93.2312 16.7229 94.6014 17.204 95.2043C17.7155 95.8498 18.087 95.1739 18.3732 96.1117C18.6594 97.0312 17.344 97.8229 17.6668 98.8033C18.2818 98.4988 19.5242 98.0299 20.4193 99.6376C21.0587 100.782 19.2501 103.785 22.1914 103.163C25.1327 102.542 25.2423 101.55 24.5177 100.874C23.793 100.198 26.0279 99.8994 25.2058 98.9738C24.3837 98.0482 26.5151 98.6084 26.6247 97.4392Z",
    fill: "#AF7120"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2588 49.3491C97.2588 51.3404 95.846 53.7823 94.1287 54.7749L39.334 86.4107C37.6106 87.4033 36.2039 86.5934 36.2039 84.6021V38.3816C36.2039 36.3903 37.6106 33.9483 39.334 32.9557L94.1287 1.31994C95.852 0.327325 97.2588 1.13725 97.2588 3.12857V49.3491Z",
    fill: "url(#paint7_linear)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7807 75.687L41.8977 76.1925V59.0318L42.7807 58.5264V75.687Z",
    fill: "#59595B"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2395 65.9557L45.3564 66.4672V51.9373L46.2395 51.4319V65.9557Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2536 67.8678L48.3706 68.3793V54.2757L49.2536 53.7642V67.8678Z",
    fill: "#59595B"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1513 72.1549L52.2683 72.6665V62.856L53.1513 62.3445V72.1549Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6101 66.5951L55.7271 67.1006V50.7072L56.6101 50.1957V66.5951Z",
    fill: "#59595B"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M60.069 59.8417L59.186 60.3471V43.6127L60.069 43.1012V59.8417Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M63.528 54.2758L62.645 54.7873V36.1773L63.528 35.6719V54.2758Z",
    fill: "#59595B"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M66.987 64.1714L66.104 64.6829V38.9419L66.987 38.4304V64.1714Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9056 32.8157C78.2348 35.5134 74.447 42.072 74.447 47.4674C74.447 52.8628 78.2348 55.049 82.9056 52.3513C87.5763 49.6536 91.3641 43.095 91.3641 37.6996L82.9056 42.5835V32.8157Z",
    fill: "#59595B"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9053 32.8158V42.5836L91.3638 37.6997C91.3638 32.3043 87.576 30.1181 82.9053 32.8158Z",
    fill: "#C0162E"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M42.336 54.026C41.4713 54.5253 40.771 54.1173 40.771 53.1247C40.771 52.126 41.4713 50.9141 42.336 50.4148C43.2008 49.9154 43.9011 50.3235 43.9011 51.3161C43.9011 52.3087 43.2008 53.5266 42.336 54.026ZM42.336 51.0177C41.7636 51.3465 41.3008 52.1564 41.3008 52.8141C41.3008 53.4779 41.7636 53.7458 42.336 53.4109C42.9085 53.0821 43.3713 52.2721 43.3713 51.6145C43.3774 50.9568 42.9085 50.6888 42.336 51.0177Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8153 41.2681C47.9506 41.7675 47.2502 41.3595 47.2502 40.3669C47.2502 39.3682 47.9506 38.1563 48.8153 37.657C49.68 37.1576 50.3803 37.5656 50.3803 38.5582C50.3803 39.5509 49.6739 40.7688 48.8153 41.2681ZM48.8153 38.2599C48.2429 38.5887 47.7739 39.3986 47.7739 40.0563C47.7739 40.7201 48.2368 40.988 48.8153 40.6531C49.3877 40.3242 49.8505 39.5143 49.8505 38.8567C49.8505 38.199 49.3816 37.931 48.8153 38.2599Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1717 43.2899C55.307 43.7892 54.6067 43.3812 54.6067 42.3886C54.6067 41.3899 55.307 40.1781 56.1717 39.6787C57.0365 39.1794 57.7367 39.5874 57.7367 40.58C57.7367 41.5726 57.0365 42.7905 56.1717 43.2899ZM56.1717 40.2816C55.5993 40.6104 55.1304 41.4204 55.1304 42.078C55.1304 42.7418 55.5932 43.0098 56.1717 42.6748C56.7442 42.346 57.2069 41.5361 57.2069 40.8784C57.2069 40.2207 56.7442 39.9528 56.1717 40.2816Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0897 28.2485C62.225 28.7478 61.5247 28.3398 61.5247 27.3472C61.5247 26.3485 62.225 25.1367 63.0897 24.6373C63.9544 24.138 64.6548 24.546 64.6548 25.5386C64.6548 26.5373 63.9483 27.7491 63.0897 28.2485ZM63.0897 25.2463C62.5173 25.5751 62.0545 26.3851 62.0545 27.0427C62.0545 27.7065 62.5173 27.9745 63.0897 27.6395C63.6621 27.3107 64.125 26.5008 64.125 25.8431C64.125 25.1854 63.6621 24.9114 63.0897 25.2463Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9879 34.6244C70.1232 35.1237 69.4229 34.7157 69.4229 33.7231C69.4229 32.7244 70.1232 31.5125 70.9879 31.0132C71.8526 30.5138 72.5529 30.9218 72.5529 31.9144C72.5529 32.9071 71.8526 34.125 70.9879 34.6244ZM70.9879 31.6161C70.4155 31.9449 69.9527 32.7548 69.9527 33.4125C69.9527 34.0763 70.4155 34.3442 70.9879 34.0093C71.5603 33.6804 72.0231 32.8705 72.0231 32.2129C72.0292 31.5552 71.5603 31.2872 70.9879 31.6161Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5477 24.211C75.683 24.7104 74.9827 24.3024 74.9827 23.3098C74.9827 22.311 75.683 21.0992 76.5477 20.5999C77.4124 20.1005 78.1128 20.5085 78.1128 21.5011C78.1128 22.4937 77.4064 23.7117 76.5477 24.211ZM76.5477 21.2027C75.9753 21.5316 75.5125 22.3415 75.5125 22.9992C75.5125 23.663 75.9753 23.9309 76.5477 23.596C77.1201 23.2671 77.583 22.4572 77.583 21.7995C77.583 21.1418 77.1201 20.8739 76.5477 21.2027Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4233 23.8828L71.5955 31.0618L72.1328 31.3483L75.9607 24.1693L75.4233 23.8828Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1062 26.8564L63.7239 27.3304L69.962 32.3616L70.3443 31.8876L64.1062 26.8564Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0507 27.9764L56.6555 39.6984L57.2087 39.953L62.6039 28.231L62.0507 27.9764Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9193 39.4452L49.7581 40.0325L55.0255 41.4789L55.1867 40.8917L49.9193 39.4452Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7056 40.9268L42.8953 50.423L43.4385 50.6982L48.2489 41.202L47.7056 40.9268Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0311 8.40234L87.8745 11.9526V10.1257L94.0311 6.57544V8.40234Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0311 11.8308L90.4321 13.9074V12.0805L94.0311 10.0039V11.8308Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M138.839 180.551H39.614V224.835H138.839V180.551Z",
    fill: "url(#paint8_linear)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M212 138.313H112.775V182.597H212V138.313Z",
    fill: "url(#paint9_linear)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4287 90.0402V160.449C74.4287 166.112 78.1739 171.782 85.6641 176.105C93.1544 180.429 102.965 182.591 112.781 182.591C122.598 182.591 132.408 180.429 139.899 176.105C147.389 171.782 151.128 166.118 151.128 160.449V90.0402H74.4287Z",
    fill: "#F1ECEC"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M112.775 90.0402L85.658 74.3837C93.1483 70.06 102.959 67.8982 112.775 67.8982C122.592 67.8982 132.402 70.06 139.893 74.3837C147.383 78.7073 151.128 84.3707 151.122 90.0402C151.122 95.7036 147.377 101.373 139.886 105.697C132.396 110.02 122.586 112.182 112.769 112.182C102.953 112.182 93.1422 110.02 85.6519 105.697C78.1617 101.373 74.4226 95.7096 74.4226 90.0402H112.775Z",
    fill: "#CACACB"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4287 90.0402C74.4287 84.3768 78.1739 78.7073 85.6641 74.3837L112.781 90.0402H74.4287Z",
    fill: "#C0162E"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M1.26123 132.284V202.693C1.26123 208.356 5.00638 214.025 12.4967 218.349C19.9869 222.673 29.7974 224.835 39.6139 224.835V132.284H1.26123Z",
    fill: "#F1ECEC"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M39.614 132.284V224.835C49.4305 224.835 59.241 222.673 66.7312 218.349C74.2215 214.025 77.9606 208.362 77.9606 202.693V132.284H39.614Z",
    fill: "#292929"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7312 116.628L39.614 132.284V154.426C49.4305 154.426 59.241 152.264 66.7312 147.941C74.2215 143.617 77.9606 137.953 77.9606 132.284C77.9606 126.615 74.2154 120.951 66.7312 116.628Z",
    fill: "#313131"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7314 116.628C59.2411 112.304 49.4307 110.142 39.6142 110.142C29.7976 110.142 19.9872 112.304 12.4969 116.628C5.00664 120.951 1.2615 126.615 1.26759 132.284C1.26759 137.947 5.01273 143.617 12.503 147.941C19.9933 152.264 29.8037 154.426 39.6202 154.426V132.284L66.7314 116.628Z",
    fill: "#F7F7FC"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M12.454 127.607C12.454 124.916 10.7489 124.837 10.7489 124.837C10.7489 124.837 9.82325 124.837 8.32519 124.215C6.84541 123.6 4.75665 123.838 5.92587 125.988C5.93805 126.012 5.95022 126.042 5.9624 126.067C6.03548 126.182 6.15727 126.292 6.33996 126.402L10.0668 128.588C10.6393 128.911 12.4418 128.162 12.454 127.607Z",
    fill: "url(#paint10_linear)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4478 127.364C12.4174 127.918 10.6331 128.655 10.0729 128.332L6.346 126.146C6.22421 126.073 6.01104 125.933 5.82227 125.762C5.8588 125.835 5.88928 125.908 5.93191 125.988C5.94409 126.012 5.95627 126.042 5.96845 126.067C6.04152 126.182 6.16331 126.292 6.346 126.402L10.0729 128.588C10.6027 128.892 12.2225 128.253 12.4357 127.717C12.4478 127.674 12.4539 127.638 12.4539 127.607C12.4539 127.522 12.4478 127.443 12.4478 127.364Z",
    fill: "#1E1C6B"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7658 124.483C11.3273 124.483 9.78056 124.879 9.78056 124.879C9.78056 124.879 9.76839 125.092 9.64051 125.281C9.62224 125.299 9.61006 125.318 9.59788 125.336C9.29339 125.549 8.98282 125.884 9.70749 126.341C10.2982 126.712 10.7854 126.475 11.0107 126.249C11.102 126.079 11.2421 125.884 11.4309 125.774C11.6257 125.659 11.7476 125.61 11.8328 125.604C11.8328 125.592 11.8389 125.567 11.8389 125.567C11.8389 125.567 11.9485 124.483 11.7658 124.483Z",
    fill: "#FFD3AB"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3019 120.519C25.6076 118.016 24.7977 115.964 24.1218 113.029C22.5019 112.706 8.20951 108.315 8.13035 111.33C8.04509 114.423 9.71974 125.038 9.71974 125.038C9.75019 125.159 9.84764 125.275 10.006 125.366C10.414 125.598 11.0716 125.598 11.4736 125.366C11.6563 125.263 11.8085 125.123 11.8268 124.983H11.8329C11.8329 124.983 11.7476 117.432 11.4736 114.198C15.9129 117.645 23.6224 121.408 26.3019 120.519Z",
    fill: "#292929"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16212 131.225C7.16212 128.533 5.45702 128.454 5.45702 128.454C5.45702 128.454 4.5314 128.454 3.03335 127.833C1.55356 127.218 -0.535197 127.455 0.627928 129.605C0.640107 129.629 0.652291 129.66 0.67056 129.684C0.743636 129.8 0.865426 129.909 1.04812 130.019L4.77498 132.205C5.34132 132.528 7.14994 131.779 7.16212 131.225Z",
    fill: "#C0162E"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14996 130.981C7.11951 131.535 5.33523 132.272 4.77498 131.949L1.04812 129.763C0.926322 129.69 0.713193 129.55 0.524414 129.38C0.560952 129.453 0.591396 129.526 0.634023 129.605C0.646203 129.629 0.658386 129.66 0.676655 129.684C0.749731 129.8 0.871522 129.909 1.05421 130.019L4.78108 132.205C5.31088 132.51 6.93073 131.87 7.14387 131.334C7.14996 131.292 7.16212 131.255 7.16212 131.225C7.16212 131.139 7.15605 131.066 7.14996 130.981Z",
    fill: "#292929"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46796 128.101C6.0295 128.101 4.48272 128.496 4.48272 128.496C4.48272 128.496 4.47052 128.71 4.34264 128.898C4.32437 128.917 4.31218 128.935 4.3 128.953C3.99552 129.166 3.68498 129.501 4.40965 129.958C5.00035 130.329 5.48749 130.092 5.71281 129.867C5.80415 129.696 5.94422 129.501 6.133 129.392C6.32787 129.276 6.44968 129.227 6.53494 129.221C6.53494 129.209 6.54103 129.185 6.54103 129.185C6.54103 129.185 6.48623 128.515 6.46796 128.101Z",
    fill: "#FFD3AB"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9393 116.743C17.3195 116.421 4.3302 110.343 3.05747 112.828C2.99657 112.944 2.9722 113.078 2.9722 113.224C2.35106 116.366 4.42154 128.655 4.42154 128.655C4.45199 128.777 4.54944 128.892 4.70778 128.984C5.11578 129.221 5.77345 129.215 6.17537 128.984C6.35806 128.88 6.51031 128.74 6.52858 128.6C6.52858 128.6 7.21063 120.665 6.99749 117.821C11.5221 121.731 18.3182 124.039 20.8393 123.978C25.6014 123.856 27.8667 121.366 28.8959 118.595C29.2673 117.59 29.444 114.91 29.444 113.753C24.6575 111.378 20.5165 114.216 18.9393 116.743Z",
    fill: "#292929"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7311 116.628C59.2409 112.304 49.4304 110.142 39.6139 110.142C36.2281 110.142 32.8483 110.404 29.5599 110.916C29.5355 111.835 29.499 112.779 29.4564 113.753C29.4564 114.916 29.2798 117.59 28.9083 118.595C27.873 121.365 25.6077 123.856 20.8517 123.978C18.629 124.033 13.0995 122.248 8.72716 119.155C8.38613 119.423 8.06339 119.691 7.74673 119.965V119.959C5.8224 121.615 4.32434 123.393 3.25256 125.232C3.23429 125.263 3.2282 125.293 3.20993 125.318C1.91892 127.571 1.26123 129.921 1.26123 132.278C1.26123 137.941 5.00638 143.611 12.4967 147.935C19.9869 152.258 29.7974 154.42 39.6139 154.42V132.278L66.7311 116.628Z",
    fill: "#CACACB"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3707 116.037C46.2393 113.918 29.4623 113.528 29.4623 113.528C29.4562 113.607 29.4562 113.68 29.4502 113.76C29.4502 114.923 29.2735 117.596 28.9021 118.601C28.5489 119.545 28.3114 119.886 28.147 120.178C27.9764 120.47 27.8608 120.629 27.7694 120.738C26.4601 122.541 24.3227 123.893 20.8455 123.978C18.6227 124.033 13.0933 122.249 8.72094 119.155C8.37992 119.423 8.05718 119.691 7.74052 119.965V119.959C7.60045 120.081 7.46649 120.202 7.33252 120.324C12.1982 123.509 16.7045 124.684 21.2047 124.684C25.705 124.684 45.9714 124.593 48.3646 122.2C50.764 119.807 50.5021 118.156 48.3707 116.037Z",
    fill: "url(#paint11_linear)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55089 112.858C2.39995 110.021 1.3099 107.305 0.274654 104.716C0.207668 104.552 0.299023 104.345 0.475623 104.241C4.71402 101.793 6.83321 100.569 11.0777 98.1213C11.1386 98.0848 11.1995 98.0726 11.2604 98.0726L11.2665 98.0665H11.0107V98.0726C10.9498 98.0726 10.8828 98.0787 10.8219 98.1213C6.58354 100.569 4.46436 101.793 0.219868 104.241C0.0493577 104.339 -0.0419975 104.552 0.018899 104.716C1.04805 107.305 2.14419 110.021 3.29514 112.858C3.34385 112.98 3.45348 113.041 3.56918 113.041V113.047H3.84318L3.83103 113.041C3.71533 113.041 3.6057 112.98 3.55089 112.858Z",
    fill: "#313131"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7983 106.397C14.8592 106.562 14.7678 106.775 14.5973 106.878C10.3589 109.326 8.23972 110.55 4.00132 112.998C3.83081 113.096 3.62986 113.041 3.55679 112.858C2.40584 110.021 1.31579 107.305 0.280547 104.716C0.213561 104.552 0.304916 104.345 0.481516 104.241C4.71992 101.793 6.8391 100.569 11.0836 98.1213C11.2541 98.0239 11.4551 98.0665 11.5221 98.231C12.6304 100.868 13.7874 103.742 14.7983 106.397Z",
    fill: "#292929"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M0.597412 104.534C0.80446 105.051 3.59352 111.994 3.82492 112.56C4.40344 112.225 13.8668 106.799 14.4453 106.47C14.2382 105.934 11.4248 98.9434 11.2056 98.4197C10.621 98.7546 1.17593 104.199 0.597412 104.534Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80132 106.275C7.41767 105.319 7.80744 104.156 8.66608 103.669C9.52472 103.182 10.5417 103.559 10.9193 104.515C11.3029 105.472 10.8949 106.61 10.0362 107.098C9.17761 107.585 8.17888 107.231 7.80132 106.275Z",
    fill: "#59595B"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51763 108.206C5.13398 107.256 5.52374 106.086 6.38239 105.599C7.24103 105.112 8.25801 105.496 8.63557 106.446C9.01312 107.396 8.6051 108.516 7.74646 109.003C6.88782 109.491 5.90128 109.15 5.51763 108.206Z",
    fill: "#292929"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M5.35975 105.301C4.9822 104.369 5.39627 103.267 6.24882 102.774C7.10746 102.281 8.094 102.591 8.47156 103.529C8.85521 104.467 8.47157 105.648 7.60684 106.135C6.7482 106.622 5.73731 106.233 5.35975 105.301Z",
    fill: "#C0162E"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8863 105.35C12.4722 105.581 12.2651 105.703 11.8571 105.934C11.6318 105.855 11.5161 105.813 11.2908 105.733C11.3334 105.612 11.3578 105.551 11.4004 105.423C11.5831 105.49 11.6744 105.52 11.8571 105.587C12.2286 105.38 12.4113 105.277 12.7766 105.064C12.8193 105.179 12.8436 105.234 12.8863 105.35Z",
    fill: "#C0162E"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7142 103.992C4.53151 103.937 4.44623 103.906 4.26354 103.852C3.89816 104.065 3.70941 104.168 3.34403 104.381C3.3014 104.278 3.28311 104.223 3.24048 104.12C3.65458 103.882 3.85554 103.766 4.26963 103.529C4.48886 103.596 4.60458 103.626 4.82381 103.699C4.78118 103.815 4.76292 103.876 4.7142 103.992Z",
    fill: "#C0162E"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M5.37159 108.656C4.90877 108.918 4.67738 109.052 4.20848 109.314C4.15976 109.198 4.1354 109.138 4.09277 109.022C4.55559 108.76 4.78698 108.626 5.25588 108.364C5.29851 108.486 5.32287 108.541 5.37159 108.656Z",
    fill: "#C0162E"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1329 117.474C11.3034 117.572 11.5896 117.572 11.7662 117.474L22.3562 111.36C22.5267 111.263 22.5267 111.098 22.3562 110.995L15.1399 106.829C14.9694 106.732 14.6832 106.732 14.5066 106.829L3.9167 112.944C3.74619 113.041 3.74619 113.205 3.9167 113.309L11.1329 117.474Z",
    fill: "#F7F7FC"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4877 107.7L15.0053 107.396L14.7495 107.25L14.2319 107.548L14.4877 107.7Z",
    fill: "#EAEEF9"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6171 108.2L14.1347 107.901L13.879 107.755L13.3613 108.054L13.6171 108.2Z",
    fill: "#EAEEF9"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M12.746 108.705L13.2636 108.407L13.0018 108.255L12.4841 108.553L12.746 108.705Z",
    fill: "#EAEEF9"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8754 109.211L12.393 108.912L12.1312 108.76L11.6135 109.058L11.8754 109.211Z",
    fill: "#EAEEF9"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9984 109.71L11.5222 109.412L11.2603 109.265L10.7427 109.564L10.9984 109.71Z",
    fill: "#EAEEF9"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1278 110.215L10.6455 109.917L10.3897 109.765L9.87207 110.063L10.1278 110.215Z",
    fill: "#EAEEF9"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25672 110.721L9.77437 110.422L9.51252 110.27L8.99487 110.569L9.25672 110.721Z",
    fill: "#EAEEF9"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38612 111.22L8.90376 110.922L8.64187 110.776L8.12427 111.074L8.38612 111.22Z",
    fill: "#EAEEF9"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50893 111.726L8.03263 111.427L7.77078 111.275L7.25317 111.579L7.50893 111.726Z",
    fill: "#EAEEF9"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63832 112.231L7.15593 111.933L6.90017 111.78L6.38257 112.079L6.63832 112.231Z",
    fill: "#EAEEF9"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76722 112.737L6.28483 112.432L6.02907 112.286L5.50537 112.584L5.76722 112.737Z",
    fill: "#EAEEF9"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89662 113.236L5.41422 112.937L5.15237 112.791L4.63477 113.09L4.89662 113.236Z",
    fill: "#EAEEF9"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9507 108.437L15.8824 107.901L15.3648 107.603L14.4331 108.139L14.9507 108.437Z",
    fill: "#EAEEF9"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4317 109.125L16.7166 108.382L16.199 108.084L14.9141 108.827L15.4317 109.125Z",
    fill: "#EAEEF9"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9492 109.838L17.5874 108.888L17.0698 108.589L15.4316 109.533L15.9492 109.838Z",
    fill: "#EAEEF9"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7155 110.033L18.6472 109.497L17.9408 109.095L17.0151 109.631L17.7155 110.033Z",
    fill: "#EAEEF9"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4303 110.776L17.362 110.24L16.6556 109.838L15.7239 110.374L16.4303 110.776Z",
    fill: "#EAEEF9"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1456 111.519L16.0712 110.983L15.3709 110.575L14.4392 111.117L15.1456 111.519Z",
    fill: "#EAEEF9"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7122 114.076L11.644 113.54L10.9376 113.138L10.0059 113.674L10.7122 114.076Z",
    fill: "#EAEEF9"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53232 115.337L10.3592 114.283L9.65893 113.875L7.83203 114.935L8.53232 115.337Z",
    fill: "#EAEEF9"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9908 113.339L14.786 111.726L14.0857 111.318L11.2905 112.931L11.9908 113.339Z",
    fill: "#EAEEF9"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8362 109.083L14.5974 108.644L14.0798 108.346L13.3125 108.784L13.8362 109.083Z",
    fill: "#EAEEF9"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3172 109.771L15.0784 109.332L14.5608 109.034L13.7996 109.472L14.3172 109.771Z",
    fill: "#EAEEF9"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8106 110.465L15.5718 110.027L15.0542 109.728L14.293 110.167L14.8106 110.465Z",
    fill: "#EAEEF9"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6903 111.111L14.4576 110.672L13.9338 110.374L13.1726 110.812L13.6903 111.111Z",
    fill: "#EAEEF9"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5757 111.756L13.3369 111.318L12.8193 111.019L12.0581 111.458L12.5757 111.756Z",
    fill: "#EAEEF9"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4612 112.402L12.2224 111.957L11.7048 111.659L10.9436 112.103L11.4612 112.402Z",
    fill: "#EAEEF9"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3409 113.047L11.1082 112.603L10.5844 112.304L9.82324 112.743L10.3409 113.047Z",
    fill: "#EAEEF9"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22635 113.687L9.98755 113.248L9.46995 112.95L8.70874 113.388L9.22635 113.687Z",
    fill: "#EAEEF9"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M7.45441 114.716L8.87327 113.893L8.35567 113.595L6.93677 114.417L7.45441 114.716Z",
    fill: "#EAEEF9"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1968 110.416L13.958 109.978L13.4404 109.679L12.6792 110.118L13.1968 110.416Z",
    fill: "#EAEEF9"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0823 111.062L12.8435 110.623L12.3259 110.319L11.5647 110.763L12.0823 111.062Z",
    fill: "#EAEEF9"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M10.968 111.707L11.7293 111.263L11.2116 110.964L10.4504 111.409L10.968 111.707Z",
    fill: "#EAEEF9"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84772 112.353L10.6089 111.908L10.0913 111.61L9.33008 112.048L9.84772 112.353Z",
    fill: "#EAEEF9"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73318 112.992L9.49439 112.554L8.97678 112.255L8.21558 112.694L8.73318 112.992Z",
    fill: "#EAEEF9"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60183 114.222L8.38 113.199L7.8624 112.901L6.08423 113.924L6.60183 114.222Z",
    fill: "#EAEEF9"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7158 109.728L13.4771 109.29L12.9594 108.991L12.1982 109.43L12.7158 109.728Z",
    fill: "#EAEEF9"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6014 110.374L12.3626 109.935L11.8449 109.637L11.0837 110.075L11.6014 110.374Z",
    fill: "#EAEEF9"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4871 111.019L11.2483 110.581L10.7307 110.276L9.96338 110.721L10.4871 111.019Z",
    fill: "#EAEEF9"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36648 111.665L10.1277 111.22L9.61008 110.922L8.84888 111.366L9.36648 111.665Z",
    fill: "#EAEEF9"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25202 112.304L9.01323 111.866L8.49558 111.567L7.73438 112.006L8.25202 112.304Z",
    fill: "#EAEEF9"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13772 112.95L7.89892 112.511L7.38132 112.213L6.61401 112.651L7.13772 112.95Z",
    fill: "#EAEEF9"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76736 113.741L6.77823 113.157L6.26062 112.858L5.24976 113.443L5.76736 113.741Z",
    fill: "#EAEEF9"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27435 112.45L13.6415 107.615L13.3919 107.469L5.02466 112.304L5.27435 112.45Z",
    fill: "#292929"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M11.991 113.961L16.2659 111.494L18.9149 113.029L14.6461 115.495L11.991 113.961Z",
    fill: "#EAEEF9"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91012 113.309L11.1264 117.474C11.2664 117.553 11.4735 117.572 11.6379 117.523C11.6379 117.523 11.7414 117.48 11.7597 117.474L22.3496 111.36C22.3618 111.354 22.3739 111.348 22.38 111.336L22.3861 111.33C22.3922 111.324 22.3983 111.318 22.4044 111.318L22.4105 111.312C22.4166 111.305 22.4227 111.299 22.4288 111.293C22.4348 111.287 22.4409 111.275 22.447 111.269C22.4592 111.245 22.4714 111.22 22.4714 111.196V111.348C22.4714 111.415 22.4287 111.482 22.3435 111.531L11.7536 117.645C11.5039 117.773 11.1386 117.748 11.035 117.724C10.9254 117.7 10.8341 117.675 10.7184 117.651L3.91012 113.717C3.82487 113.668 3.78223 113.601 3.78223 113.534V113.138C3.78223 113.193 3.82487 113.26 3.91012 113.309Z",
    fill: "url(#paint12_linear)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5341 109.052L14.9143 109.99L19.8226 112.822V112.986L21.4424 112.048V111.884L16.5341 109.052Z",
    fill: "url(#paint13_linear)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8613 98.103C22.7029 99.327 22.9222 100.849 20.9613 104.436C20.3402 105.569 18.0139 108.705 17.1857 109.241C16.936 108.839 15.8947 108.431 15.7059 108.328C15.5172 108.224 14.8777 108.151 14.5123 108.376C14.4271 108.425 14.1531 108.583 13.946 108.754C13.5989 109.028 13.9338 109.308 14.3236 109.265C14.7133 109.223 14.8107 109.332 15.1944 109.649C15.2614 109.704 15.3223 109.771 15.3771 109.838C15.1518 109.746 14.7986 109.497 14.5428 109.789C14.7559 109.929 15.4867 110.313 16.0774 110.392C16.2418 110.422 16.9178 110.398 17.1979 110.349C18.4402 110.148 21.2232 108.382 23.0988 105.843C26.3324 101.458 26.6247 99.6315 26.6308 98.5354C26.6551 95.6001 23.0683 96.0873 22.8613 98.103Z",
    fill: "url(#paint14_linear)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4613 119.368C21.4726 121.603 16.3878 120.69 18.2634 116.171C19.2804 114.003 19.6883 110.215 19.6092 107.95C19.2377 107.103 18.0502 106.836 17.4839 104.601C17.356 102.871 17.3316 102.195 17.6605 98.7972C19.0976 97.0982 19.7675 96.3187 21.3752 95.6854C22.3434 95.3017 23.604 94.8145 24.5296 95.3809C28.5427 97.8533 29.8215 105.337 29.4501 113.753C29.036 116.506 27.4283 118.266 25.4613 119.368Z",
    fill: "#292929"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6528 95.7401C22.9951 95.0764 22.7698 93.5966 22.6967 92.4213C22.7881 91.7758 22.7759 91.0876 22.6237 90.3812C22.0756 87.8479 20.0295 86.1428 18.0442 86.5691C16.0651 86.9954 14.8959 89.3947 15.444 91.928C15.9494 94.2725 17.8859 95.6244 19.7067 95.8802C19.8955 96.2456 19.4205 96.8484 19.1586 97.1347C20.6445 97.5853 22.1365 96.7145 22.8916 96.3369C23.2813 96.142 23.5615 95.9533 23.6528 95.7401Z",
    fill: "#FFD3AB"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6441 113.54L11.3456 113.595C11.096 113.595 10.8463 113.735 9.7806 113.358C9.48221 113.248 9.06813 112.858 8.7332 112.852C8.36782 112.852 8.08769 112.828 7.89282 112.791C8.0816 112.858 8.36173 112.919 8.7332 112.974C9.06204 113.023 9.42135 113.473 9.70147 113.619C9.87198 113.711 10.012 113.772 10.1399 113.833L14.1104 116.122V116.281L15.986 115.197V115.038L12.6915 113.138C12.2774 113.358 11.9181 113.498 11.6441 113.54Z",
    fill: "url(#paint15_linear)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5815 99.2601C17.4232 100.484 17.3684 103.791 15.4075 107.372C14.7864 108.504 12.7768 111.981 11.7354 112.304C11.5832 112.274 11.4005 112.237 11.1447 111.939C10.7855 111.506 10.3957 111.22 10.1521 111.038C9.90246 111.208 10.28 111.671 10.4992 111.86C10.4992 111.86 10.0669 111.72 9.65887 111.561C9.44573 111.482 8.46529 111.397 8.31914 111.403C7.43005 111.452 7.25953 111.671 7.81978 111.762C6.87589 111.738 7.19256 112.048 7.48486 112.109C7.16211 112.243 7.21083 112.456 7.72236 112.481C7.30827 112.67 7.67363 112.846 8.72714 112.852C9.06207 112.852 9.47618 113.248 9.77458 113.358C10.8403 113.741 11.0899 113.595 11.3396 113.595L11.638 113.54C12.8803 113.339 15.6633 111.318 17.5389 108.778C20.7725 104.394 21.3388 100.789 21.351 99.6864C21.3693 96.7573 17.7886 97.2445 17.5815 99.2601Z",
    fill: "url(#paint16_linear)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6247 97.4392C26.7465 96.1117 25.7234 95.6245 24.6151 94.6258C22.8674 93.0486 24.0244 93.3043 23.2023 90.3509C22.3802 87.3974 19.9565 85.2416 16.8386 86.3073C15.2614 86.8493 14.3236 89.4191 15.9434 91.3495C18.2758 93.2312 16.7229 94.6014 17.204 95.2043C17.7155 95.8498 18.087 95.1739 18.3732 96.1117C18.6594 97.0312 17.344 97.8229 17.6668 98.8033C18.2818 98.4988 19.5242 98.0299 20.4193 99.6376C21.0587 100.782 19.2501 103.785 22.1914 103.163C25.1327 102.542 25.2423 101.55 24.5177 100.874C23.793 100.198 26.0279 99.8994 25.2058 98.9738C24.3837 98.0482 26.5151 98.6084 26.6247 97.4392Z",
    fill: "#AF7120"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2588 49.3491C97.2588 51.3404 95.846 53.7823 94.1287 54.7749L39.334 86.4107C37.6106 87.4033 36.2039 86.5934 36.2039 84.6021V38.3816C36.2039 36.3903 37.6106 33.9483 39.334 32.9557L94.1287 1.31994C95.852 0.327325 97.2588 1.13725 97.2588 3.12857V49.3491Z",
    fill: "url(#paint17_linear)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7807 75.687L41.8977 76.1925V59.0318L42.7807 58.5264V75.687Z",
    fill: "#59595B"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2395 65.9557L45.3564 66.4672V51.9373L46.2395 51.4319V65.9557Z",
    fill: "white"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2536 67.8678L48.3706 68.3793V54.2757L49.2536 53.7642V67.8678Z",
    fill: "#59595B"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1513 72.1549L52.2683 72.6665V62.856L53.1513 62.3445V72.1549Z",
    fill: "white"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6101 66.5951L55.7271 67.1006V50.7072L56.6101 50.1957V66.5951Z",
    fill: "#59595B"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M60.069 59.8417L59.186 60.3471V43.6127L60.069 43.1012V59.8417Z",
    fill: "white"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M63.528 54.2758L62.645 54.7873V36.1773L63.528 35.6719V54.2758Z",
    fill: "#59595B"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M66.987 64.1714L66.104 64.6829V38.9419L66.987 38.4304V64.1714Z",
    fill: "white"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9056 32.8157C78.2348 35.5134 74.447 42.072 74.447 47.4674C74.447 52.8628 78.2348 55.049 82.9056 52.3513C87.5763 49.6536 91.3641 43.095 91.3641 37.6996L82.9056 42.5835V32.8157Z",
    fill: "#59595B"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9053 32.8158V42.5836L91.3638 37.6997C91.3638 32.3043 87.576 30.1181 82.9053 32.8158Z",
    fill: "#C0162E"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M42.336 54.026C41.4713 54.5253 40.771 54.1173 40.771 53.1247C40.771 52.126 41.4713 50.9141 42.336 50.4148C43.2008 49.9154 43.9011 50.3235 43.9011 51.3161C43.9011 52.3087 43.2008 53.5266 42.336 54.026ZM42.336 51.0177C41.7636 51.3465 41.3008 52.1564 41.3008 52.8141C41.3008 53.4779 41.7636 53.7458 42.336 53.4109C42.9085 53.0821 43.3713 52.2721 43.3713 51.6145C43.3774 50.9568 42.9085 50.6888 42.336 51.0177Z",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8153 41.2681C47.9506 41.7675 47.2502 41.3595 47.2502 40.3669C47.2502 39.3682 47.9506 38.1563 48.8153 37.657C49.68 37.1576 50.3803 37.5656 50.3803 38.5582C50.3803 39.5509 49.6739 40.7688 48.8153 41.2681ZM48.8153 38.2599C48.2429 38.5887 47.7739 39.3986 47.7739 40.0563C47.7739 40.7201 48.2368 40.988 48.8153 40.6531C49.3877 40.3242 49.8505 39.5143 49.8505 38.8567C49.8505 38.199 49.3816 37.931 48.8153 38.2599Z",
    fill: "white"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1717 43.2899C55.307 43.7892 54.6067 43.3812 54.6067 42.3886C54.6067 41.3899 55.307 40.1781 56.1717 39.6787C57.0365 39.1794 57.7367 39.5874 57.7367 40.58C57.7367 41.5726 57.0365 42.7905 56.1717 43.2899ZM56.1717 40.2816C55.5993 40.6104 55.1304 41.4204 55.1304 42.078C55.1304 42.7418 55.5932 43.0098 56.1717 42.6748C56.7442 42.346 57.2069 41.5361 57.2069 40.8784C57.2069 40.2207 56.7442 39.9528 56.1717 40.2816Z",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0897 28.2485C62.225 28.7478 61.5247 28.3398 61.5247 27.3472C61.5247 26.3485 62.225 25.1367 63.0897 24.6373C63.9544 24.138 64.6548 24.546 64.6548 25.5386C64.6548 26.5373 63.9483 27.7491 63.0897 28.2485ZM63.0897 25.2463C62.5173 25.5751 62.0545 26.3851 62.0545 27.0427C62.0545 27.7065 62.5173 27.9745 63.0897 27.6395C63.6621 27.3107 64.125 26.5008 64.125 25.8431C64.125 25.1854 63.6621 24.9114 63.0897 25.2463Z",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9879 34.6244C70.1232 35.1237 69.4229 34.7157 69.4229 33.7231C69.4229 32.7244 70.1232 31.5125 70.9879 31.0132C71.8526 30.5138 72.5529 30.9218 72.5529 31.9144C72.5529 32.9071 71.8526 34.125 70.9879 34.6244ZM70.9879 31.6161C70.4155 31.9449 69.9527 32.7548 69.9527 33.4125C69.9527 34.0763 70.4155 34.3442 70.9879 34.0093C71.5603 33.6804 72.0231 32.8705 72.0231 32.2129C72.0292 31.5552 71.5603 31.2872 70.9879 31.6161Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5477 24.211C75.683 24.7104 74.9827 24.3024 74.9827 23.3098C74.9827 22.311 75.683 21.0992 76.5477 20.5999C77.4124 20.1005 78.1128 20.5085 78.1128 21.5011C78.1128 22.4937 77.4064 23.7117 76.5477 24.211ZM76.5477 21.2027C75.9753 21.5316 75.5125 22.3415 75.5125 22.9992C75.5125 23.663 75.9753 23.9309 76.5477 23.596C77.1201 23.2671 77.583 22.4572 77.583 21.7995C77.583 21.1418 77.1201 20.8739 76.5477 21.2027Z",
    fill: "white"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4233 23.8828L71.5955 31.0618L72.1328 31.3483L75.9607 24.1693L75.4233 23.8828Z",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1062 26.8564L63.7239 27.3304L69.962 32.3616L70.3443 31.8876L64.1062 26.8564Z",
    fill: "white"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0507 27.9764L56.6555 39.6984L57.2087 39.953L62.6039 28.231L62.0507 27.9764Z",
    fill: "white"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9193 39.4452L49.7581 40.0325L55.0255 41.4789L55.1867 40.8917L49.9193 39.4452Z",
    fill: "white"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7056 40.9268L42.8953 50.423L43.4385 50.6982L48.2489 41.202L47.7056 40.9268Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0311 8.40234L87.8745 11.9526V10.1257L94.0311 6.57544V8.40234Z",
    fill: "white"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0311 11.8308L90.4321 13.9074V12.0805L94.0311 10.0039V11.8308Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M156.444 134.56C156.444 135.883 155.481 137.528 154.358 138.209L120.15 157.941C118.987 158.623 118.064 158.062 118.064 156.738V125.696C118.064 124.373 119.027 122.729 120.15 122.047L154.358 102.315C155.521 101.633 156.444 102.195 156.444 103.518V134.56Z",
    fill: "url(#paint18_linear)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M118.025 156.738V125.697C118.025 124.373 118.987 122.729 120.11 122.047L154.319 102.315C154.88 101.994 155.402 101.954 155.803 102.155L154.64 101.473C154.239 101.232 153.717 101.272 153.156 101.593L118.947 121.325C117.784 122.007 116.862 123.651 116.862 124.975V156.016C116.862 156.698 117.102 157.179 117.503 157.38L118.626 158.022C118.225 157.861 118.025 157.38 118.025 156.738Z",
    fill: "#292929"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M123.318 136.284L121.754 137.167V135.362L123.318 134.44V136.284Z",
    fill: "#292929"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M126.647 134.359L125.043 135.282V133.437L126.647 132.514V134.359Z",
    fill: "#292929"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M129.975 132.434L128.371 133.357V131.512L129.975 130.589V132.434Z",
    fill: "#292929"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M133.304 130.509L131.7 131.432V129.587L133.304 128.664V130.509Z",
    fill: "#292929"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M136.633 128.584L135.029 129.506V127.662L136.633 126.739V128.584Z",
    fill: "#C0162E"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M139.962 126.659L138.357 127.581V125.737L139.962 124.814V126.659Z",
    fill: "#59595B"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M143.29 124.734L141.686 125.656V123.812L143.29 122.929V124.734Z",
    fill: "#59595B"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M123.318 140.094L121.754 141.017V139.172L123.318 138.29V140.094Z",
    fill: "#C0162E"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M126.647 138.169L125.043 139.092V137.287L126.647 136.365V138.169Z",
    fill: "#C0162E"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M129.975 136.284L128.371 137.167V135.362L129.975 134.44V136.284Z",
    fill: "#C0162E"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M133.304 134.359L131.7 135.282V133.437L133.304 132.514V134.359Z",
    fill: "#C0162E"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M136.633 132.434L135.029 133.357V131.512L136.633 130.589V132.434Z",
    fill: "#C0162E"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M139.962 130.509L138.357 131.432V129.587L139.962 128.664V130.509Z",
    fill: "#59595B"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M143.29 128.584L141.686 129.506V127.662L143.29 126.739V128.584Z",
    fill: "#59595B"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M123.318 143.944L121.754 144.867V143.022L123.318 142.1V143.944Z",
    fill: "#C0162E"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M126.647 142.019L125.043 142.942V141.097L126.647 140.175V142.019Z",
    fill: "#C0162E"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M129.975 140.094L128.371 141.017V139.172L129.975 138.29V140.094Z",
    fill: "#C0162E"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M133.304 138.169L131.7 139.092V137.287L133.304 136.365V138.169Z",
    fill: "#C0162E"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M136.633 136.284L135.029 137.167V135.362L136.633 134.44V136.284Z",
    fill: "#C0162E"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M139.962 134.359L138.357 135.282V133.437L139.962 132.514V134.359Z",
    fill: "#59595B"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M143.29 132.434L141.686 133.357V131.512L143.29 130.589V132.434Z",
    fill: "#59595B"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M123.318 147.795L121.754 148.717V146.872L123.318 145.95V147.795Z",
    fill: "#C0162E"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M126.647 145.87L125.043 146.792V144.947L126.647 144.025V145.87Z",
    fill: "#C0162E"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M129.975 143.944L128.371 144.867V143.022L129.975 142.1V143.944Z",
    fill: "#C0162E"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M133.304 142.019L131.7 142.942V141.097L133.304 140.175V142.019Z",
    fill: "#C0162E"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M136.633 140.094L135.029 141.017V139.172L136.633 138.29V140.094Z",
    fill: "#C0162E"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M139.962 138.169L138.357 139.092V137.287L139.962 136.365V138.169Z",
    fill: "#59595B"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M143.29 136.284L141.686 137.167V135.362L143.29 134.44V136.284Z",
    fill: "#59595B"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M123.318 151.645L121.754 152.527V150.722L123.318 149.8V151.645Z",
    fill: "#C0162E"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M126.647 149.72L125.043 150.642V148.797L126.647 147.875V149.72Z",
    fill: "#C0162E"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M129.975 147.795L128.371 148.717V146.872L129.975 145.95V147.795Z",
    fill: "#C0162E"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M133.304 145.87L131.7 146.792V144.947L133.304 144.025V145.87Z",
    fill: "#C0162E"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M136.633 143.944L135.029 144.867V143.022L136.633 142.1V143.944Z",
    fill: "#292929"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M139.962 142.019L138.357 142.942V141.097L139.962 140.175V142.019Z",
    fill: "#292929"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M143.29 140.094L141.686 141.017V139.172L143.29 138.29V140.094Z",
    fill: "#292929"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M129.976 122.127L121.755 126.9V129.226L129.976 124.453V122.127Z",
    fill: "#C0162E"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M153.356 125.857L146.739 129.707V132.554L153.356 128.704V125.857Z",
    fill: "#C0162E"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M153.356 130.83L146.739 134.68V137.528L153.356 133.677V130.83Z",
    fill: "#C0162E"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M152.153 114.387C152.354 114.668 152.434 115.069 152.434 115.55C152.434 117.074 151.351 118.919 150.028 119.681C148.704 120.443 147.622 119.841 147.622 118.317C147.622 116.793 148.704 114.949 150.028 114.187V112.462C147.902 113.705 146.138 116.713 146.138 119.16C146.138 121.646 147.862 122.649 150.028 121.405C152.153 120.162 153.918 117.154 153.918 114.708C153.918 113.946 153.757 113.304 153.437 112.823L152.153 114.387Z",
    fill: "#59595B"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M152.154 114.387L153.477 112.823C152.835 111.82 151.552 111.62 150.068 112.462V114.186C150.95 113.625 151.752 113.745 152.154 114.387Z",
    fill: "#C0162E"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M168.318 180.373H148.766V183.967H168.318V180.373Z",
    fill: "url(#paint19_linear)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M177.149 175.196H157.597V178.79H177.149V175.196Z",
    fill: "url(#paint20_linear)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M159.79 177.693C159.79 174.892 158.024 174.77 158.024 174.77C158.024 174.77 157.049 174.77 155.466 174.1C153.943 173.43 151.75 173.734 152.969 175.988C152.969 175.988 152.969 176.049 153.029 176.049C153.09 176.171 153.212 176.292 153.456 176.414L157.354 178.729C157.841 179.033 159.729 178.242 159.79 177.693Z",
    fill: "#AE2C34"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M159.729 177.389C159.668 177.998 157.841 178.729 157.232 178.424L153.334 176.11C153.212 176.049 152.969 175.866 152.786 175.683C152.847 175.744 152.847 175.805 152.908 175.927C152.908 175.927 152.908 175.988 152.969 175.988C153.03 176.11 153.151 176.232 153.395 176.353L157.293 178.668C157.841 178.972 159.547 178.302 159.79 177.754C159.79 177.693 159.79 177.693 159.79 177.632C159.79 177.571 159.729 177.511 159.729 177.389Z",
    fill: "url(#paint21_linear)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M159.059 174.404C158.572 174.404 156.988 174.831 156.988 174.831C156.988 174.831 156.988 175.074 156.866 175.257C156.866 175.257 156.866 175.318 156.806 175.318C156.501 175.562 156.136 175.866 156.927 176.354C157.536 176.719 158.024 176.475 158.267 176.232C158.389 176.049 158.511 175.866 158.694 175.744C158.876 175.623 158.998 175.562 159.12 175.562V175.501C159.12 175.501 159.242 174.404 159.059 174.404Z",
    fill: "white"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M159.059 146.813C157.293 146.874 152.908 146.935 151.141 146.935C151.811 152.234 153.09 157.046 154.004 162.223C154.979 167.217 156.014 170.75 156.928 174.892C157.293 175.683 158.816 175.379 159.12 174.648C159.364 170.811 159.668 166.182 158.511 161.736C158.755 156.924 159.181 151.625 159.059 146.813Z",
    fill: "black"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M150.837 182.871C150.837 180.069 149.071 179.947 149.071 179.947C149.071 179.947 148.096 179.947 146.512 179.277C144.99 178.607 142.797 178.912 144.015 181.165C144.015 181.165 144.015 181.226 144.076 181.226C144.137 181.348 144.259 181.47 144.502 181.592L148.401 183.906C148.949 184.211 150.837 183.419 150.837 182.871Z",
    fill: "#AE2C34"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M150.837 182.627C150.776 183.236 148.949 183.967 148.34 183.662L144.442 181.348C144.32 181.287 144.076 181.104 143.894 180.922C143.954 180.982 143.954 181.043 144.015 181.165C144.015 181.165 144.015 181.226 144.076 181.226C144.137 181.348 144.259 181.47 144.503 181.591L148.401 183.906C148.949 184.211 150.654 183.541 150.898 182.992C150.898 182.931 150.898 182.931 150.898 182.871C150.837 182.749 150.837 182.688 150.837 182.627Z",
    fill: "url(#paint22_linear)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M150.106 179.582C149.619 179.582 148.035 180.008 148.035 180.008C148.035 180.008 148.035 180.252 147.913 180.435C147.913 180.435 147.913 180.495 147.852 180.495C147.548 180.739 147.182 181.044 147.974 181.531C148.583 181.896 149.071 181.653 149.314 181.409C149.436 181.226 149.558 181.044 149.741 180.922C149.923 180.8 150.045 180.739 150.167 180.739V180.678C150.167 180.678 150.35 179.582 150.106 179.582Z",
    fill: "white"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M153.456 159.421C153.943 157.168 159.486 156.863 159.12 147.91C157.354 147.666 148.583 151.808 146.817 151.503C146.573 156.863 147.121 161.797 147.121 167.035C147.243 172.09 147.73 175.745 147.974 180.008C148.157 180.8 149.801 180.8 150.228 180.13C151.08 176.415 152.116 171.846 151.75 167.278C152.299 164.781 152.908 162.101 153.456 159.421Z",
    fill: "black"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M155.101 131.586C161.313 135.728 162.044 144.012 158.694 149.25C158.694 149.25 159.425 137.616 155.101 131.586Z",
    fill: "url(#paint23_linear)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M155.892 165.877C152.116 168.009 146.269 166.425 144.807 163.38C145.294 158.507 147.304 143.707 146.33 139.017C146.634 136.459 146.878 136.459 146.512 134.936C148.035 133.292 150.715 129.881 151.933 129.637C155.953 128.784 158.389 134.266 159.059 141.331C159.242 143.341 159.851 157.472 159.79 159.604C159.729 162.649 157.719 164.842 155.892 165.877Z",
    fill: "url(#paint24_linear)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M154.795 130.246C153.699 129.454 153.821 128.906 154.004 127.81C154.247 127.262 154.369 126.592 154.369 125.922C154.369 123.486 152.786 121.354 150.897 121.476C147.06 121.719 147.73 123.79 147.73 126.226C147.73 128.48 148.766 130.064 150.471 130.307C150.471 130.673 149.557 131.464 149.192 132.013C151.08 133.474 153.029 131.769 153.76 131.464C154.491 131.099 155.344 130.794 154.795 130.246Z",
    fill: "#F6D3AF"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M152.542 121.658C152.055 121.415 151.568 121.536 151.324 121.354C150.654 120.927 150.045 120.684 149.68 120.866C149.497 120.988 149.192 121.232 149.192 121.232C148.827 121.597 148.157 120.867 147.974 121.719C147.913 121.963 147.913 122.206 147.913 122.389C146.269 122.572 147.061 124.095 148.401 127.018C148.401 126.531 149.375 125.435 149.375 127.566C149.375 127.81 149.192 127.81 149.375 128.115C149.497 128.419 150.471 129.15 151.081 129.759C151.933 130.612 152.786 129.515 154.248 129.698C154.065 129.394 154.065 129.089 154.309 128.724C154.43 128.48 155.222 127.688 155.222 126.348C154.126 126.531 156.136 123.486 152.542 121.658Z",
    fill: "#AF7120"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M134.636 142.306C135.61 141.514 137.316 141.271 138.473 141.697C139.569 142.062 139.691 142.489 140.117 142.976C139.813 143.281 140.056 143.707 138.899 143.951C138.351 143.768 137.803 144.255 136.95 143.402C136.097 142.55 136.158 142.306 136.158 142.306C134.392 142.793 134.392 142.55 134.636 142.306Z",
    fill: "#F4D1AD"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M147.792 134.022C145.782 133.657 145.356 140.113 145.356 144.316C144.381 143.89 141.214 142.976 139.752 142.489C138.534 142.489 138.047 143.28 138.899 144.438C140.727 145.656 145.538 149.006 147.67 148.275C149.802 147.544 149.802 142.245 149.985 139.626C150.228 137.068 150.228 134.449 147.792 134.022Z",
    fill: "url(#paint25_linear)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 83.1184,
    y: 212.788,
    width: 49.2504,
    height: 28.4146,
    fill: "url(#pattern0)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2973 216.097C87.3817 215.56 87.3817 214.676 88.2973 214.171L113.68 199.522C114.596 198.985 116.111 198.985 117.058 199.522L128.645 206.215C129.56 206.752 129.56 207.636 128.645 208.141L103.23 222.79C102.315 223.327 100.799 223.327 99.8522 222.79L88.2973 216.097Z",
    fill: "white"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M114.312 203.657L115.417 203.026L114.312 202.395L113.239 203.026L114.312 203.657Z",
    fill: "#292929"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M112.481 204.699L113.586 204.068L112.481 203.437L111.407 204.068L112.481 204.699Z",
    fill: "#292929"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M110.65 205.741L111.755 205.141L110.65 204.51L109.576 205.141L110.65 205.741Z",
    fill: "#292929"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M108.85 206.815L109.924 206.183L108.85 205.552L107.745 206.183L108.85 206.815Z",
    fill: "#292929"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M107.019 207.857L108.092 207.225L107.019 206.625L105.914 207.225L107.019 207.857Z",
    fill: "#292929"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M105.188 208.93L106.261 208.299L105.188 207.667L104.083 208.299L105.188 208.93Z",
    fill: "#292929"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M103.357 209.972L104.43 209.341L103.357 208.709L102.283 209.341L103.357 209.972Z",
    fill: "#292929"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M101.525 211.014L102.599 210.414L101.525 209.782L100.452 210.414L101.525 211.014Z",
    fill: "#292929"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6943 212.087L100.768 211.456L99.6943 210.824L98.6208 211.456L99.6943 212.087Z",
    fill: "#292929"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8637 213.129L98.9687 212.498L97.8637 211.898L96.7903 212.498L97.8637 213.129Z",
    fill: "#292929"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0324 214.202L97.1374 213.571L96.0324 212.94L94.959 213.571L96.0324 214.202Z",
    fill: "#292929"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2013 215.244L95.3063 214.613L94.2013 213.981L93.1279 214.613L94.2013 215.244Z",
    fill: "#292929"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M115.291 205.205L117.217 204.068L116.143 203.437L114.186 204.573L115.291 205.205Z",
    fill: "#292929"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M116.301 206.625L118.984 205.078L117.879 204.447L115.196 206.025L116.301 206.625Z",
    fill: "#292929"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M117.374 208.109L120.815 206.152L119.71 205.52L116.301 207.509L117.374 208.109Z",
    fill: "#292929"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M121.068 208.551L123.025 207.415L121.542 206.562L119.584 207.699L121.068 208.551Z",
    fill: "#292929"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 210.098L120.311 208.961L118.858 208.109L116.901 209.246L118.385 210.098Z",
    fill: "#292929"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M115.67 211.645L117.627 210.54L116.175 209.688L114.217 210.793L115.67 211.645Z",
    fill: "#292929"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M106.388 217.012L108.345 215.876L106.893 215.023L104.935 216.16L106.388 217.012Z",
    fill: "#292929"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M101.841 219.633L105.662 217.423L104.178 216.602L100.358 218.812L101.841 219.633Z",
    fill: "#292929"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M109.071 215.465L114.943 212.087L113.46 211.235L107.619 214.613L109.071 215.465Z",
    fill: "#292929"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M112.954 206.562L114.533 205.615L113.459 205.015L111.849 205.931L112.954 206.562Z",
    fill: "#292929"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M113.933 207.983L115.543 207.067L114.47 206.436L112.86 207.351L113.933 207.983Z",
    fill: "#292929"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M114.975 209.435L116.585 208.519L115.48 207.888L113.901 208.804L114.975 209.435Z",
    fill: "#292929"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M112.638 210.793L114.248 209.877L113.143 209.246L111.565 210.161L112.638 210.793Z",
    fill: "#292929"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M110.302 212.15L111.913 211.235L110.808 210.603L109.229 211.519L110.302 212.15Z",
    fill: "#292929"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M107.966 213.508L109.576 212.561L108.471 211.961L106.893 212.876L107.966 213.508Z",
    fill: "#292929"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M105.63 214.834L107.24 213.918L106.135 213.287L104.556 214.202L105.63 214.834Z",
    fill: "#292929"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M103.294 216.191L104.872 215.276L103.799 214.644L102.22 215.56L103.294 216.191Z",
    fill: "#292929"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5683 218.338L102.536 216.633L101.463 216.002L98.4949 217.707L99.5683 218.338Z",
    fill: "#292929"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M111.597 209.341L113.207 208.425L112.134 207.794L110.523 208.709L111.597 209.341Z",
    fill: "#292929"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M109.261 210.698L110.871 209.782L109.797 209.151L108.187 210.066L109.261 210.698Z",
    fill: "#292929"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M106.924 212.024L108.534 211.109L107.429 210.477L105.851 211.424L106.924 212.024Z",
    fill: "#292929"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M104.588 213.382L106.198 212.466L105.093 211.835L103.515 212.75L104.588 213.382Z",
    fill: "#292929"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M102.252 214.739L103.862 213.824L102.757 213.192L101.178 214.108L102.252 214.739Z",
    fill: "#292929"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8003 217.328L101.526 215.181L100.421 214.55L96.6953 216.697L97.8003 217.328Z",
    fill: "#292929"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M110.587 207.888L112.197 206.972L111.123 206.341L109.513 207.257L110.587 207.888Z",
    fill: "#292929"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M108.25 209.246L109.861 208.33L108.787 207.699L107.177 208.614L108.25 209.246Z",
    fill: "#292929"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M105.914 210.603L107.524 209.688L106.451 209.056L104.841 209.972L105.914 210.603Z",
    fill: "#292929"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M103.578 211.961L105.188 211.014L104.083 210.414L102.504 211.329L103.578 211.961Z",
    fill: "#292929"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M101.241 213.287L102.851 212.371L101.747 211.74L100.168 212.687L101.241 213.287Z",
    fill: "#292929"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9049 214.644L100.515 213.729L99.4101 213.097L97.8315 214.013L98.9049 214.644Z",
    fill: "#292929"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0324 216.318L98.1792 215.086L97.0742 214.455L94.959 215.686L96.0324 216.318Z",
    fill: "#292929"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M128.614 208.141L103.231 222.79C102.315 223.327 100.8 223.327 99.8526 222.79L88.2661 216.097C87.7925 215.844 87.5715 215.465 87.5715 215.118V215.844C87.5715 216.192 87.7925 216.539 88.2661 216.823L99.8526 223.516C100.768 224.053 102.284 224.053 103.231 223.516L128.614 208.867C129.087 208.583 129.308 208.235 129.308 207.888V207.162C129.308 207.509 129.056 207.857 128.614 208.141Z",
    fill: "#BDC1E4"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6243 191.092C86.6243 190.019 87.382 188.724 88.2975 188.188L113.68 173.538C114.596 173.001 115.354 173.443 115.354 174.517V196.586C115.354 197.659 114.596 198.953 113.68 199.49L88.2975 214.14C87.382 214.676 86.6243 214.234 86.6243 213.161V191.092Z",
    fill: "url(#paint26_linear)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2974 214.171L113.68 199.522C114.596 198.985 115.354 197.691 115.354 196.617V176.253C113.08 177.579 114.059 183.452 112.323 184.431C111.123 185.125 110.839 181.968 109.039 182.978C107.177 184.052 106.419 192.923 104.335 194.155C102.662 195.133 102.41 192.355 100.736 193.302C98.4947 194.597 98.5263 200.69 96.3479 201.953C94.0748 203.279 92.2753 194.66 90.1285 195.891C88.9288 196.586 87.5081 201.069 86.5925 203.531V213.224C86.6241 214.266 87.3818 214.708 88.2974 214.171Z",
    fill: "url(#paint27_linear)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M101.052 205.268L100.484 205.615V193.428L101.052 193.113V205.268Z",
    fill: "#292929"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M101.297 193.584C101.602 193.055 101.605 192.485 101.303 192.311C101.001 192.137 100.509 192.424 100.204 192.952C99.8985 193.481 99.8959 194.05 100.198 194.225C100.5 194.399 100.992 194.112 101.297 193.584Z",
    fill: "#292929"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4332 188.661L89.2761 190.461V189.261L92.4332 187.43V188.661Z",
    fill: "#C0162E"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1491 190.398L89.2761 192.071V191.282L92.1491 189.64V190.398Z",
    fill: "#C0162E"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6244 213.192V191.124C86.6244 190.05 87.3821 188.756 88.2976 188.219L113.681 173.57C114.123 173.317 114.565 173.286 114.849 173.444L113.965 172.938C113.649 172.749 113.239 172.749 112.733 173.033L87.3505 187.682C86.435 188.219 85.6772 189.514 85.6772 190.587V212.656C85.6772 213.224 85.8982 213.603 86.214 213.761L87.0664 214.234C86.7822 214.045 86.6244 213.698 86.6244 213.192Z",
    fill: "#292929"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M118.605 238.324C118.605 235.608 116.869 235.514 116.869 235.514C116.869 235.514 115.922 235.514 114.406 234.882C112.923 234.251 110.807 234.503 111.975 236.682C111.975 236.713 112.007 236.745 112.007 236.777C112.07 236.903 112.196 236.998 112.386 237.124L116.143 239.334C116.774 239.65 118.605 238.892 118.605 238.324Z",
    fill: "url(#paint28_linear)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M118.606 238.071C118.574 238.639 116.775 239.365 116.206 239.05L112.449 236.84C112.323 236.776 112.102 236.619 111.913 236.461C111.944 236.524 111.976 236.619 112.007 236.682C112.007 236.713 112.039 236.745 112.039 236.776C112.102 236.903 112.228 236.997 112.418 237.124L116.175 239.334C116.711 239.649 118.353 238.986 118.574 238.45C118.574 238.418 118.606 238.355 118.606 238.355C118.606 238.229 118.606 238.166 118.606 238.071Z",
    fill: "black"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M117.911 235.166C117.469 235.166 115.922 235.577 115.922 235.577C115.922 235.577 115.922 235.798 115.796 235.987C115.764 236.019 115.764 236.019 115.764 236.05C115.448 236.271 115.133 236.619 115.859 237.061C116.459 237.44 116.932 237.187 117.185 236.966C117.279 236.777 117.406 236.587 117.595 236.492C117.785 236.366 117.911 236.335 118.006 236.335V236.303C118.006 236.303 118.1 235.166 117.911 235.166Z",
    fill: "white"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M132.591 231.157C131.897 228.631 131.581 225.947 130.886 222.98C129.245 222.664 116.237 216.318 114.469 219.728C114.406 219.854 114.375 219.98 114.375 220.138C113.743 223.295 115.827 235.703 115.827 235.703C115.859 235.829 115.953 235.956 116.111 236.05C116.522 236.271 117.185 236.271 117.595 236.05C117.784 235.956 117.942 235.798 117.942 235.671C117.942 235.671 118.858 228.284 118.574 225.032C123.088 228.505 129.876 232.072 132.591 231.157Z",
    fill: "black"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M113.27 241.986C113.27 239.271 111.534 239.176 111.534 239.176C111.534 239.176 110.587 239.176 109.071 238.545C107.587 237.913 105.472 238.166 106.64 240.344C106.64 240.376 106.672 240.407 106.672 240.439C106.735 240.565 106.861 240.66 107.051 240.786L110.808 242.996C111.407 243.28 113.239 242.523 113.27 241.986Z",
    fill: "#C0162E"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M113.239 241.733C113.207 242.302 111.408 243.028 110.839 242.712L107.082 240.502C106.956 240.439 106.735 240.281 106.546 240.123C106.577 240.186 106.609 240.281 106.64 240.344C106.64 240.376 106.672 240.407 106.672 240.439C106.735 240.565 106.861 240.66 107.051 240.786L110.808 242.996C111.344 243.312 112.986 242.649 113.207 242.112C113.207 242.081 113.239 242.018 113.239 242.018C113.27 241.891 113.239 241.828 113.239 241.733Z",
    fill: "#20196F"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M112.544 238.829C112.102 238.829 110.524 239.239 110.524 239.239C110.524 239.239 110.524 239.46 110.397 239.65C110.366 239.681 110.366 239.681 110.366 239.713C110.05 239.934 109.734 240.281 110.46 240.723C111.06 241.102 111.534 240.849 111.786 240.628C111.881 240.439 112.007 240.249 112.197 240.155C112.386 240.028 112.512 239.997 112.607 239.997V239.965C112.607 239.965 112.733 238.829 112.544 238.829Z",
    fill: "white"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M109.04 223.801C108.408 226.958 110.492 239.366 110.492 239.366C110.523 239.492 110.618 239.618 110.776 239.713C111.186 239.934 111.849 239.934 112.26 239.713C112.449 239.618 112.607 239.46 112.607 239.334C112.607 239.334 113.523 231.946 113.238 228.694C111.755 227.558 109.04 225.726 109.04 223.801Z",
    fill: "#292929"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M150.303 235.861H130.666L149.924 246.974L130.666 258.087H150.303L169.529 246.974L150.303 235.861Z",
    fill: "url(#paint29_linear)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M130.666 258.087L149.924 246.974V232.609L130.666 243.722V258.087Z",
    fill: "#59595B"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M130.666 258.087L111.407 246.974V232.609L130.666 243.722V258.087Z",
    fill: "#E0E0E0"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M130.666 243.722L111.407 232.609L130.666 221.496L149.924 232.609L130.666 243.722Z",
    fill: "#BDBDBD"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M121.162 213.161C120.72 212.782 120.784 212.845 120.278 212.466C120.247 212.371 120.247 212.277 120.215 212.182C120.089 212.119 119.963 212.087 119.9 212.087C119.521 212.119 119.205 212.087 118.984 212.024C118.637 211.929 117.911 209.94 116.206 210.035C116.679 210.414 117.311 211.203 117.185 211.14C117.185 211.14 116.806 210.856 116.395 211.203C116.679 211.424 117.626 212.087 118.416 212.277C118.637 212.34 118.921 212.371 119.331 212.34C119.394 212.34 119.489 212.371 119.647 212.434C119.647 212.529 119.647 212.624 119.71 212.719C120.121 213.034 120.436 213.318 120.626 213.476C120.72 213.413 121.068 213.224 121.162 213.161Z",
    fill: "url(#paint30_linear)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M112.26 215.528C112.228 215.465 112.228 215.371 112.228 215.307C110.618 215.402 110.176 214.329 109.702 213.824C109.197 213.318 109.102 213.161 108.566 213.161C108.029 213.161 107.587 212.719 108.124 212.403C108.25 212.308 108.408 212.245 108.534 212.182C108.503 212.182 108.471 212.213 108.439 212.213C108.313 212.277 107.903 212.434 107.587 212.655C107.05 212.971 107.492 213.413 108.029 213.413C108.566 213.413 108.692 213.571 109.166 214.076C109.639 214.581 110.081 215.655 111.691 215.56C111.691 215.623 111.723 215.718 111.723 215.781C112.702 216.539 112.923 216.823 113.743 217.454L114.312 217.139C113.522 216.476 113.238 216.255 112.26 215.528Z",
    fill: "url(#paint31_linear)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M125.235 215.813C125.709 215.907 126.246 215.97 126.814 215.907C126.94 215.907 127.066 215.876 127.193 215.844C126.909 216.034 126.593 216.128 126.246 216.16C125.74 216.191 125.298 216.16 124.856 216.097C125.014 216.002 125.141 215.907 125.235 215.813Z",
    fill: "url(#paint32_linear)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M125.551 226.642C123.909 226.326 110.902 219.98 109.134 223.39C109.071 223.516 109.04 223.642 109.04 223.8C109.04 225.726 111.755 227.557 113.27 228.694C117.753 232.167 124.541 235.734 127.256 234.819C131.644 233.367 133.823 232.198 135.243 229.231C135.717 228.252 135.812 225.505 135.812 224.337C130.918 221.938 127.13 224.116 125.551 226.642Z",
    fill: "#292929"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M116.332 209.435C116.648 209.246 117.058 209.056 117.185 208.993C117.721 208.74 118.605 208.93 118.858 209.119C119.11 209.277 120.594 210.224 120.878 210.824C120.878 210.824 121.447 211.108 121.668 211.235L120.847 212.498C120.847 212.498 120.121 212.119 119.963 212.119C119.584 212.15 119.268 212.119 119.047 212.056C118.226 211.835 117.279 211.203 117.027 210.982C117.437 210.603 117.879 211.014 118.163 211.172C118.1 211.077 118.037 210.982 117.942 210.887C117.437 210.382 117.342 210.224 116.806 210.224C116.206 210.193 115.795 209.751 116.332 209.435Z",
    fill: "#FCD1A9"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M120.279 212.466C119.995 211.614 121.005 210.824 121.637 210.888C124.478 212.119 125.867 212.877 126.814 212.561C130.887 210.667 129.245 215.687 126.814 215.876C123.973 216.16 122.552 214.234 120.279 212.466Z",
    fill: "black"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M132.117 206.089C134.17 206.531 136.758 207.857 135.022 211.424C133.854 213.887 132.117 206.089 132.117 206.089Z",
    fill: "black"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M131.739 230.02C127.729 232.293 122.236 231.441 121.51 228.284C124.256 219.096 124.856 212.971 124.793 209.246C126.561 207.888 128.076 206.657 129.371 206.373C130.728 206.057 132.528 205.836 133.317 206.594C135.78 209.94 135.148 215.687 135.748 224.369C135.338 227.116 133.696 228.884 131.739 230.02Z",
    fill: "black"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M131.234 206.247C130.539 205.615 130.35 204.542 130.223 203.374C130.286 202.711 130.255 202.016 130.065 201.321C129.434 198.796 127.287 197.154 125.298 197.628C123.309 198.133 122.236 200.595 122.867 203.121C123.467 205.457 125.519 206.752 127.382 206.973C127.477 207.162 127.129 207.446 126.814 207.667C128.329 208.078 129.75 207.289 130.476 206.878C130.886 206.657 131.139 206.468 131.234 206.247Z",
    fill: "#FCD1A9"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M113.523 214.076C113.302 213.95 112.954 213.761 112.954 213.761C112.954 213.634 112.512 212.214 111.281 211.866C111.029 212.245 111.471 212.561 111.818 212.908C111.407 212.561 110.839 212.245 110.618 212.056C110.366 211.898 109.513 211.677 108.945 211.929C108.819 211.993 108.408 212.15 108.092 212.371C107.556 212.687 107.998 213.129 108.534 213.129C109.071 213.129 109.197 213.287 109.671 213.792C110.176 214.297 110.587 215.371 112.228 215.276C112.386 215.276 112.607 215.402 112.607 215.402L113.523 214.076Z",
    fill: "#FCD1A9"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M112.259 215.529C111.975 214.676 112.986 213.887 113.617 213.95C116.458 215.181 117.847 215.939 118.795 215.623C122.867 213.729 123.751 210.161 124.762 209.214C127.035 207.604 129.781 211.172 126.782 214.424C123.625 217.391 121.194 218.749 118.763 218.97C115.985 219.222 114.533 217.265 112.259 215.529Z",
    fill: "black"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M130.602 200.848C130.602 200.816 130.602 200.816 130.602 200.848C130.192 199.585 129.56 198.48 128.487 197.785C125.709 195.954 124.572 196.112 124.32 196.554C121.352 196.207 120.689 197.785 122.709 200.027C123.278 200.785 123.025 202.931 124.067 203.247C123.941 202.774 124.698 201.384 125.235 203.531C125.298 203.752 125.14 203.847 125.361 204.131C125.582 204.384 126.75 204.92 127.571 205.394C128.708 206.057 129.024 205.11 130.539 204.92C130.381 204.289 130.476 203.91 130.602 203.468C130.697 203.152 130.823 202.016 130.602 200.848Z",
    fill: "#FFCF6E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 5.58235,
    y1: 126.291,
    x2: 12.4569,
    y2: 126.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5555C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#3D3B9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34318F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 28.7003,
    y1: 113.528,
    x2: 28.7003,
    y2: 124.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 22.4809,
    y1: 114.46,
    x2: 3.78125,
    y2: 114.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5618,
    stopColor: "#A7ADCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#D0D4F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 14.9136,
    y1: 111.018,
    x2: 21.4436,
    y2: 111.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4783,
    stopColor: "#EAECF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8037,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 13.7972,
    y1: 103.431,
    x2: 26.6337,
    y2: 103.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0348,
    stopColor: "#FED1A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3073,
    stopColor: "#F5C398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6099,
    stopColor: "#F1BB8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB88B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 9.16288,
    y1: 115.428,
    x2: 14.8247,
    y2: 112.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4783,
    stopColor: "#EAECF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8037,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 6.73544,
    y1: 111.52,
    x2: 22.6523,
    y2: 100.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3997,
    stopColor: "#FED1A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#F9C99F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9538,
    stopColor: "#F1BB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB88B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 66.6975,
    y1: 69.8153,
    x2: 44.3106,
    y2: 33.2255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 89.2264,
    y1: 180.551,
    x2: 89.2264,
    y2: 224.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 162.388,
    y1: 138.313,
    x2: 162.388,
    y2: 182.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 5.58235,
    y1: 126.291,
    x2: 12.4569,
    y2: 126.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5555C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#3D3B9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34318F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 28.7003,
    y1: 113.528,
    x2: 28.7003,
    y2: 124.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 22.4809,
    y1: 114.46,
    x2: 3.78125,
    y2: 114.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5618,
    stopColor: "#A7ADCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6124,
    stopColor: "#D0D4F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 14.9136,
    y1: 111.018,
    x2: 21.4436,
    y2: 111.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4783,
    stopColor: "#EAECF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8037,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 13.7972,
    y1: 103.431,
    x2: 26.6337,
    y2: 103.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0348,
    stopColor: "#FED1A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3073,
    stopColor: "#F5C398"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6099,
    stopColor: "#F1BB8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB88B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 9.16288,
    y1: 115.428,
    x2: 14.8247,
    y2: 112.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4CAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4783,
    stopColor: "#EAECF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8037,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 6.73544,
    y1: 111.52,
    x2: 22.6523,
    y2: 100.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3997,
    stopColor: "#FED1A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#F9C99F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9538,
    stopColor: "#F1BB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB88B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 66.6975,
    y1: 69.8153,
    x2: 44.3106,
    y2: 33.2255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1821,
    stopColor: "#2C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5834,
    stopColor: "#871C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#C02828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 137.254,
    y1: 102.024,
    x2: 137.254,
    y2: 158.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 158.542,
    y1: 180.373,
    x2: 158.542,
    y2: 183.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 167.373,
    y1: 175.196,
    x2: 156.684,
    y2: 173.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 152.805,
    y1: 177.255,
    x2: 159.758,
    y2: 177.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353434",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 143.902,
    y1: 182.438,
    x2: 150.855,
    y2: 182.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353434",
    stopOpacity: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 155.212,
    y1: 140.41,
    x2: 160.96,
    y2: 140.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    stopColor: "#8F8FA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 144.813,
    y1: 148.22,
    x2: 159.772,
    y2: 148.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    stopColor: "#8F8FA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 138.741,
    y1: 141.177,
    x2: 151.115,
    y2: 141.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59595B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    stopColor: "#8F8FA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 100.989,
    y1: 173.31,
    x2: 100.989,
    y2: 214.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 100.004,
    y1: 187.353,
    x2: 107.633,
    y2: 209.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#59595B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 111.664,
    y1: 236.995,
    x2: 118.602,
    y2: 236.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#362E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#362E94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 150.098,
    y1: 235.861,
    x2: 150.098,
    y2: 258.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: 118.684,
    y1: 210.032,
    x2: 118.684,
    y2: 213.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: 110.828,
    y1: 212.182,
    x2: 110.828,
    y2: 217.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x1: 126.243,
    y1: 216.433,
    x2: 125.943,
    y2: 215.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E19100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5836,
    stopColor: "#F3AC04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBA06"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJwAAABaCAYAAABNCT/kAAAACXBIWXMAAAsSAAALEgHS3X78AAAA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataSciencePreview);
export default __webpack_public_path__ + "static/media/data_science_preview.0f96d74fc3fb575b20808e63c09df7f8.svg";
export { ForwardRef as ReactComponent };